import { Stack, Typography } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router";

import GaiaTableLinkCell from "~/modules/app/components/GaiaTableLinkCell";
import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatDateTime } from "~/modules/app/util/formatters";
import VisitStatusChip from "~/shared/components/VisitStatusChip";

import type { VisitListScreenFragment } from "./fragments.generated";

export function useAdministratorColumns(): GridColDef[] {
    const { t } = useTranslation("planner");

    return [
        {
            field: "plannerArea.name",
            headerName: t("visitListScreen.areaName"),
            valueGetter: (_, row) => row.plannerArea?.name,
            flex: 1,
        },
        {
            field: "protocol.name",
            headerName: t("visitListScreen.protocol"),
            renderCell: ({ row }) => (
                <Stack>
                    <Typography variant="body1">{row.protocol?.name}</Typography>
                    <Typography variant="caption">
                        {row.protocolVisit?.name ?? t("visitListScreen.visitName")} {row.protocolVisit?.number ?? ""}
                    </Typography>
                </Stack>
            ),
            flex: 1,
        },
        {
            field: "requiredFieldworkers",
            headerName: t("visitListScreen.requiredWorkers"),
            valueGetter: (_, row) => row.requiredFieldworkers,
            flex: 3 / 4,
        },
        {
            field: "startTime",
            headerName: t("visitListScreen.startTime"),
            valueGetter: (_, row) => (row.startTime !== null ? formatDateTime(parseStringToDate(row.startTime)) : null),
            flex: 3 / 4,
        },
        {
            field: "status",
            headerName: t("visitListScreen.status"),
            renderCell: ({ row }: GridRenderCellParams<VisitListScreenFragment>) => <VisitStatusChip value={row.status} />,
            flex: 1,
        },
        {
            type: "actions",
            field: "",
            headerName: "",
            maxWidth: 40,
            valueGetter: (_, visit) =>
                generatePath("/c/:clientSlug/p/:projectSlug/review-visit/:visitId/", {
                    clientSlug: visit.plannerArea.project.client.slug,
                    projectSlug: visit.plannerArea.project.slug,
                    visitId: visit.id,
                }),
            renderCell: (props: GridRenderCellParams<VisitListScreenFragment>) => <GaiaTableLinkCell value={props.value} />,
        },
    ];
}
